import { z } from 'zod/v4';

export const RuleDocumentSchema = z.object({
  documentType: z.string().min(1),
  isMandatory: z.boolean(),
  isAppliedToAllCountries: z.boolean(),
  idx: z.number().int().min(0),
  countryCodes: z.array(z.string()).optional().default([]),
});

export const RuleSchema = z.object({
  isBackupRule: z.boolean().optional().default(false),
  idx: z.number().int().min(0),
  facilityProcessIds: z.array(z.string()).optional().default([]),
  documents: z.array(RuleDocumentSchema).optional().default([]),
});

export const CreateBodySchema = z.object({
  name: z.string().min(1),
  description: z.string().nullable().optional(),
  // Product Backward is the only tracing type left (Fiber Forward is retired).
  tracingType: z.enum(['PRODUCT_BACKWARD']),
  isActive: z.boolean().optional().default(true),
  rules: z.array(RuleSchema).optional().default([]),
});

export type CreateBodyType = z.infer<typeof CreateBodySchema>;
